import React from 'react';

import { AppTemplate } from '../AppTemplate';
import { routeConfig } from './routes';

const App = () => (
  <AppTemplate routeConfig={routeConfig} />
);

export default App;



// WEBPACK FOOTER //
// ./src/apps/static-pages/App.js